import React from 'react';
import { Container } from 'react-bootstrap'

function Header(props) {
  return (
    <Container className={"flex-container"} fluid >
      <div>
        <img className={'da-logo'} src="/Logo.svg" alt="DocsApp Logo" />
      </div>
      <div>
        {props.headerFlag ?<h5>Book your e-Consultation</h5> : '' }
      </div>
      <div >
        <img src="Max-logo.png" alt="Max Bupa Logo" />
      </div>
    </Container>
  )
}

export default Header;

